export const BUILD_VERSION = '1776880958';
